import { cx } from "@emotion/css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button, Popup, PopupAction, PopupMain } from "@/components";
import { FetchDataError, useModal } from "@/hooks";
import { getDeviceByID } from "@/shared/requests/device";
import { getStorage } from "@/shared/store";

interface ServiceConfigDoneBTNProps {
  className?: string;
}

export const ServiceConfigDoneBTN: React.FC<ServiceConfigDoneBTNProps> = ({ className }) => {
  const { visible: noBuildingVisible, toggle: noBuildingToggle } = useModal();
  const [isPending, setIsPending] = useState(false);
  const navigate = useNavigate();
  const device_id = getStorage("deviceId");

  const handleSetSpotClick = async () => {
    setIsPending(true);
    await getDeviceByID({ device_type: "PATMO", device_id })
      .then(({ data: device }) => {
        setIsPending(false);
        const isBuildingUploaded = !!device?.building_uploaded;
        if (isBuildingUploaded) {
          navigate("/status");
        } else if (!isBuildingUploaded) {
          noBuildingToggle();
        }
      })
      .catch((e) => {
        FetchDataError(true, e);
      });
  };
  return (
    <>
      <div className={cx(className)}>
        <Button onClick={handleSetSpotClick} loading={isPending}>
          完了
        </Button>
      </div>
      <Popup visible={noBuildingVisible}>
        <PopupMain className="!text-base">{"棟情報がありません。「部屋情報アップロード」を押してください。"}</PopupMain>
        <PopupAction className="!mt-[13px] flex justify-center">
          <Button className="w-[124px]" size="normal" onClick={noBuildingToggle}>
            閉じる
          </Button>
        </PopupAction>
      </Popup>
    </>
  );
};
